// import React, { useState } from 'react';
// import logo from "../asset/logo.png";
// import {Link } from 'react-router';
// import { HiOutlineUserCircle } from "react-icons/hi";
// import { useDispatch, useSelector } from 'react-redux';
// import { logoutRedux } from '../redux/userSlice';
// import toast from 'react-hot-toast';
// import { BsCartFill } from 'react-icons/bs';

// const Header= () => {
//   const [showMenu, setShowMenu]= useState(false)
//   const userData= useSelector((state)=>state.user)
//   const productData = useSelector((state) => state.product.productList); // Access product list
//   const dispatch= useDispatch()

//   const handleShowMenu= ()=>{
//     setShowMenu(preve=> !preve)
//   }

//   const handleLogout= ()=>{
//       dispatch(logoutRedux());
//       toast("Logout successfully");
//   }

//   const cartItemNumber= useSelector((state)=>state.product.cartItem)
//   return (
//     <header className= 'fixed shadow-md w-full h-16 px-2 md:px-4 z-50 bg-white'>
//       {/* Desktop version */}

//       <div className= 'flex items-center h-full justify-between'>
//         <Link to={""}>
//           <div className= 'h-10'>
//             <img src= {logo} alt='logo' className='h-full' />
//           </div>
//         </Link>

//         <div className= "flex items-center gap-4 md:gap-7">
//           <nav className= "gap-4 md:gap-6 text-base md:text-lg hidden md:flex">
//             <Link to={"/"}>Home</Link>
//             {/* <Link to={"menu/67842b3d8e480725a13fb108"}>Menu</Link> */}
//             <Link to={`/menu/${productData[0]?._id || 'defaultId'}`}>Menu</Link>
//             <Link to={"about"}>About</Link>
//             <Link to={"contact"}>Contact</Link>
//           </nav>
//           <div className= "text-2xl text-slate-600 relative">
//             <Link to={"cart"}><BsCartFill />
//               <div className= "absolute -top-1 -right-1 text-white bg-red-500 h-4 w-4 rounded-full m-0 p-0 text-sm text-center">
//                 {cartItemNumber.length}
//               </div>
//             </Link>
//           </div>
//           <div className= "text-slate-600" onClick={handleShowMenu}>
//             <div className= "text-3xl cursor-pointer w-8 h-8 rounded-full overflow-hidden drop-shadow-md">
//               {userData.image? <img src= {userData.image} alt="profileImage" className='h-full w-full' /> :<HiOutlineUserCircle /> }
//             </div>
//             {
//               showMenu && (
//               <div className='absolute right-2 bg-white py-2  shadow drop-shadow-md flex flex-col min-w-[120px] text-center'>
//                 {
//                   process.env.REACT_APP_ADMIN_EMAIL=== userData.email && <Link to={"newproduct"} className='whiteSpace-nowrap cursor-pointer px-2'>New Product</Link>
//                 }


//               {
//                 userData.email? <p className='cursor-pointer text-white px-2 bg-red-500' onClick= {handleLogout}>Logout ({userData.firstName}) </p> : <Link to={"login"} className='whiteSpace-nowrap cursor-pointer px-2'>Login</Link>
//               }
//               <nav className= "text-base md:text-lg  flex flex-col md:hidden">
//                 <Link to={"/"} className='px-2 py-1'>Home</Link>
//                 <Link to={"menu/677e87761155df9564927db8"} className='px-2 py-1'>Menu</Link>
//                 <Link to={"about"} className='px-2 py-1'>About</Link>
//                 <Link to={"contact"} className='px-2 py-1'>Contact</Link>
//               </nav>
//               </div>
//             )}


//           </div>
//         </div>
//       </div>
//       {/* Mobile version */}



//     </header>
//   )
// }

// export default Header


import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Link, useNavigate, useLocation } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { logoutRedux } from '../redux/userSlice';
import toast from 'react-hot-toast';

// ── Icons (react-icons) ───────────────────────────────────────────────────────
import { BsCartFill, BsLightningChargeFill } from 'react-icons/bs';
import { HiOutlineUserCircle, HiOutlineSearch, HiX, HiMenu } from 'react-icons/hi';
import { RiDashboardLine, RiLogoutBoxLine, RiLoginBoxLine } from 'react-icons/ri';
import { MdOutlineInventory2 } from 'react-icons/md';
import { IoChevronDownOutline } from 'react-icons/io5';
const NAV = [
  { label: 'Home', to: '/' },
  { label: 'Menu', to: '__MENU__' }, // resolved dynamically
  { label: 'About', to: '/about' },
  { label: 'Contact', to: '/contact' },
];

export default function Header() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const userData = useSelector(s => s.user);
  const cartItems = useSelector(s => s.product.cartItem);
  const productList = useSelector(s => s.product.productList);

  const [scrolled, setScrolled] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [profileOpen, setProfileOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const searchRef = useRef(null);
  const inputRef = useRef(null);
  const profileRef = useRef(null);

  // ── Scroll detection ─────────────────────────────────────────────────────
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    setMobileOpen(false);
    setSearchOpen(false);
    setProfileOpen(false);
  }, [location.pathname]);

  // ── Live search ───────────────────────────────────────────────────────────
  useEffect(() => {
    const q = searchQuery.trim().toLowerCase();
    if (!q) { setSearchResults([]); return; }
    const hits = productList
      .filter(p =>
        p.name.toLowerCase().includes(q) ||
        p.category.toLowerCase().includes(q)
      )
      .slice(0, 6);
    setSearchResults(hits);
  }, [searchQuery, productList]);

  const openSearch = useCallback(() => {
    setSearchOpen(true);
    setTimeout(() => inputRef.current?.focus(), 80);
  }, []);

  const closeSearch = useCallback(() => {
    setSearchOpen(false);
    setSearchQuery('');
    setSearchResults([]);
  }, []);

  // Close on outside click
  useEffect(() => {
    const handler = (e) => {
      if (searchRef.current && !searchRef.current.contains(e.target)) closeSearch();
      if (profileRef.current && !profileRef.current.contains(e.target)) setProfileOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [closeSearch]);

  // Keyboard shortcut: "/" opens search
  useEffect(() => {
    const handler = (e) => {
      if (e.key === '/' && !searchOpen && e.target.tagName !== 'INPUT' && e.target.tagName !== 'TEXTAREA') {
        e.preventDefault();
        openSearch();
      }
      if (e.key === 'Escape') { closeSearch(); setProfileOpen(false); }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [searchOpen, openSearch, closeSearch]);

  const handleLogout = () => {
    dispatch(logoutRedux());
    setProfileOpen(false);
    toast.success('Logged out');
    navigate('/');
  };

  const menuLink = `/menu/${productList[0]?._id || 'default'}`;

  // ── Helpers ───────────────────────────────────────────────────────────────
  const isActive = (to) => {
    const resolved = to === '__MENU__' ? '/menu' : to;
    if (resolved === '/') return location.pathname === '/';
    return location.pathname.startsWith(resolved);
  };

  return (
    <>
      {/* ── Main bar ─────────────────────────────────────────────────────── */}
      <header
        className={`
          fixed top-0 left-0 right-0 z-50
          transition-all duration-500
          ${scrolled
            ? 'glass border-b border-[var(--glass-border)] shadow-[0_4px_30px_rgba(0,0,0,0.5)]'
            : 'bg-transparent border-b border-transparent'
          }
        `}
        style={{ height: 64 }}
      >
        <div className="max-w-7xl mx-auto px-4 md:px-6 h-full flex items-center justify-between gap-4">

          {/* ── Logo ──────────────────────────────────────────────────────── */}
          <Link to="/" className="flex items-center gap-2 group flex-shrink-0">
            <div className="relative w-8 h-8 flex items-center justify-center">
              {/* ring */}
              <span
                className="absolute inset-0 rounded-full border border-indigo-DEFAULT opacity-60
                           group-hover:opacity-100 group-hover:scale-110 transition-all duration-300"
                style={{ borderColor: 'var(--indigo)' }}
              />
              <BsLightningChargeFill
                className="relative z-10 text-lg group-hover:scale-110 transition-transform duration-300"
                style={{ color: 'var(--cyan)' }}
              />
            </div>
            <span
              className="font-display text-base font-bold tracking-widest uppercase leading-none"
            >
              <span className="text-gradient">Home</span>
              <span style={{ color: 'var(--text-primary)' }}> Electric</span>
            </span>
          </Link>

          {/* ── Desktop nav ───────────────────────────────────────────────── */}
          <nav className="hidden md:flex items-center gap-1">
            {NAV.map(({ label, to }) => {
              const href = to === '__MENU__' ? menuLink : to;
              const active = isActive(to);
              return (
                <Link
                  key={label}
                  to={href}
                  className={`
                    relative px-4 py-2 text-[0.72rem] font-display font-medium
                    tracking-[0.12em] uppercase transition-all duration-200
                    ${active
                      ? 'text-gradient'
                      : 'text-[var(--text-muted)] hover:text-[var(--text-secondary)]'
                    }
                  `}
                >
                  {label}
                  {/* active underline */}
                  <span
                    className={`
                      absolute bottom-0 left-3 right-3 h-px rounded-full
                      transition-all duration-300
                      ${active ? 'opacity-100' : 'opacity-0 scale-x-0'}
                    `}
                    style={{ background: 'var(--grad-brand)' }}
                  />
                </Link>
              );
            })}
          </nav>

          {/* ── Right actions ─────────────────────────────────────────────── */}
          <div className="flex items-center gap-2">

            {/* Search trigger */}
            <button
              onClick={openSearch}
              aria-label="Search"
              className="
                relative flex items-center gap-2 px-3 py-1.5 rounded-lg
                glass border border-[var(--glass-border)]
                text-[var(--text-muted)] hover:text-[var(--text-secondary)]
                hover:border-[var(--indigo)] hover:bg-[var(--indigo-dim)]
                transition-all duration-200 text-sm
              "
            >
              <HiOutlineSearch className="text-base flex-shrink-0" />
              <span className="hidden sm:inline text-[0.72rem] font-mono tracking-wider">
                Search
              </span>
              <kbd
                className="hidden sm:flex items-center text-[0.6rem] font-mono
                           border border-[var(--glass-border)] rounded px-1 py-0.5
                           text-[var(--text-faint)]"
              >
                /
              </kbd>
            </button>

            {/* Cart */}
            <Link
              to="/cart"
              className="
                relative p-2 rounded-lg
                glass border border-[var(--glass-border)]
                hover:border-[var(--indigo)] hover:bg-[var(--indigo-dim)]
                transition-all duration-200
              "
              aria-label="Cart"
            >
              <BsCartFill style={{ color: 'var(--text-secondary)' }} className="text-lg" />
              {cartItems.length > 0 && (
                <span
                  className="
                    absolute -top-1.5 -right-1.5
                    min-w-[18px] h-[18px] px-1
                    flex items-center justify-center
                    rounded-full text-[0.6rem] font-display font-bold
                    animate-pulse-glow
                  "
                  style={{
                    background: 'var(--grad-brand)',
                    color: 'var(--bg-void)',
                  }}
                >
                  {cartItems.length}
                </span>
              )}
            </Link>

            {/* Profile dropdown */}
            <div className="relative" ref={profileRef}>
              <button
                onClick={() => setProfileOpen(p => !p)}
                className="
                  flex items-center gap-1.5 p-1.5 rounded-lg
                  glass border border-[var(--glass-border)]
                  hover:border-[var(--indigo)] hover:bg-[var(--indigo-dim)]
                  transition-all duration-200
                "
                aria-label="Profile"
              >
                <div className="w-7 h-7 rounded-full overflow-hidden flex items-center justify-center"
                  style={{ background: 'var(--bg-raised)' }}>
                  {userData.image
                    ? <img src={userData.image} alt="avatar" className="w-full h-full object-cover" />
                    : <HiOutlineUserCircle className="text-xl" style={{ color: 'var(--text-muted)' }} />
                  }
                </div>
                <IoChevronDownOutline
                  className={`text-xs transition-transform duration-200 ${profileOpen ? 'rotate-180' : ''}`}
                  style={{ color: 'var(--text-muted)' }}
                />
              </button>

              {/* Dropdown */}
              {profileOpen && (
                <div
                  className="
                    absolute right-0 top-full mt-2
                    glass-md rounded-2xl overflow-hidden
                    min-w-[200px] animate-scale-up shadow-glass
                  "
                  style={{ border: '1px solid var(--glass-border)' }}
                >
                  {/* User info */}
                  {userData.email && (
                    <div className="px-4 py-3 border-b" style={{ borderColor: 'var(--glass-border)' }}>
                      <p className="text-xs font-mono truncate" style={{ color: 'var(--text-muted)' }}>
                        {userData.email}
                      </p>
                      <p className="text-sm font-semibold mt-0.5 truncate" style={{ color: 'var(--text-primary)' }}>
                        {userData.firstName} {userData.lastName}
                      </p>
                    </div>
                  )}

                  {/* Admin only */}
                  {process.env.REACT_APP_ADMIN_EMAIL === userData.email && (
                    <Link
                      to="/newproduct"
                      className="flex items-center gap-3 px-4 py-3 text-sm transition-all duration-150 hover:bg-[var(--glass-2)]"
                      style={{ color: 'var(--text-secondary)' }}
                      onClick={() => setProfileOpen(false)}
                    >
                      <MdOutlineInventory2 className="text-base flex-shrink-0" style={{ color: 'var(--amber)' }} />
                      New Product
                    </Link>
                  )}

                  {userData.email ? (
                    <button
                      onClick={handleLogout}
                      className="w-full flex items-center gap-3 px-4 py-3 text-sm transition-all duration-150 hover:bg-[var(--coral-dim)]"
                      style={{ color: 'var(--coral)' }}
                    >
                      <RiLogoutBoxLine className="text-base flex-shrink-0" />
                      Logout
                    </button>
                  ) : (
                    <Link
                      to="/login"
                      className="flex items-center gap-3 px-4 py-3 text-sm transition-all duration-150 hover:bg-[var(--indigo-dim)]"
                      style={{ color: 'var(--indigo-light)' }}
                      onClick={() => setProfileOpen(false)}
                    >
                      <RiLoginBoxLine className="text-base flex-shrink-0" />
                      Login / Sign Up
                    </Link>
                  )}
                </div>
              )}
            </div>

            {/* Mobile hamburger */}
            <button
              onClick={() => setMobileOpen(p => !p)}
              className="
                md:hidden p-2 rounded-lg
                glass border border-[var(--glass-border)]
                hover:border-[var(--indigo)]
                transition-all duration-200
              "
              aria-label="Menu"
            >
              {mobileOpen
                ? <HiX className="text-xl" style={{ color: 'var(--text-secondary)' }} />
                : <HiMenu className="text-xl" style={{ color: 'var(--text-secondary)' }} />
              }
            </button>
          </div>
        </div>
      </header>

      {/* ── Mobile drawer ──────────────────────────────────────────────────── */}
      {mobileOpen && (
        <div
          className="
            fixed top-16 left-0 right-0 z-40
            glass-md border-b border-[var(--glass-border)]
            animate-fade-up
          "
          style={{ backdropFilter: 'blur(32px)' }}
        >
          {NAV.map(({ label, to }) => {
            const href = to === '__MENU__' ? menuLink : to;
            const active = isActive(to);
            return (
              <Link
                key={label}
                to={href}
                className={`
                  block px-6 py-4 text-sm font-display tracking-[0.1em] uppercase
                  border-b border-[var(--glass-border)]
                  transition-colors duration-150
                  ${active
                    ? 'text-gradient bg-[var(--indigo-dim)]'
                    : 'text-[var(--text-muted)] hover:text-[var(--text-secondary)] hover:bg-[var(--glass-1)]'
                  }
                `}
              >
                {label}
              </Link>
            );
          })}
        </div>
      )}

      {/* ── Search overlay ─────────────────────────────────────────────────── */}
      {searchOpen && (
        <>
          {/* Backdrop */}
          <div
            className="fixed inset-0 z-[60] bg-black/60 backdrop-blur-sm animate-fade-in"
            onClick={closeSearch}
          />

          {/* Panel */}
          <div
            ref={searchRef}
            className="
              fixed top-20 left-1/2 -translate-x-1/2 z-[70]
              w-full max-w-xl mx-4
              glass-hi rounded-2xl overflow-hidden
              shadow-glass animate-scale-up
            "
            style={{ border: '1px solid var(--glass-border-h)' }}
          >
            {/* Input row */}
            <div
              className="flex items-center gap-3 px-4 py-3 border-b"
              style={{ borderColor: 'var(--glass-border)' }}
            >
              <HiOutlineSearch className="text-xl flex-shrink-0" style={{ color: 'var(--indigo-light)' }} />
              <input
                ref={inputRef}
                type="text"
                placeholder="Search products, categories…"
                className="flex-1 bg-transparent outline-none text-sm placeholder:text-[var(--text-muted)]"
                style={{ color: 'var(--text-primary)', fontFamily: 'var(--font-body)' }}
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
              />
              <button onClick={closeSearch} className="flex-shrink-0 p-1 hover:opacity-60 transition-opacity">
                <HiX style={{ color: 'var(--text-muted)' }} />
              </button>
            </div>

            {/* Results */}
            {searchResults.length > 0 ? (
              <ul>
                {searchResults.map((p, i) => (
                  <li
                    key={p._id}
                    className="animate-fade-up"
                    style={{ animationDelay: `${i * 40}ms` }}
                  >
                    <Link
                      to={`/menu/${p._id}`}
                      onClick={closeSearch}
                      className="
                        flex items-center gap-4 px-4 py-3
                        border-b border-[var(--glass-border)]
                        hover:bg-[var(--indigo-dim)] transition-all duration-150
                        last:border-0
                      "
                      style={{ color: 'var(--text-primary)' }}
                    >
                      <div
                        className="w-12 h-12 rounded-xl flex-shrink-0 overflow-hidden flex items-center justify-center"
                        style={{ background: 'var(--bg-raised)' }}
                      >
                        <img src={p.image} alt={p.name} className="w-full h-full object-contain p-1" />
                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-semibold truncate capitalize">{p.name}</p>
                        <p className="text-xs mt-0.5 font-mono" style={{ color: 'var(--text-muted)' }}>
                          {p.category}
                        </p>
                      </div>
                      <p className="text-sm font-display font-bold flex-shrink-0" style={{ color: 'var(--cyan)' }}>
                        ₹{p.price}
                      </p>
                    </Link>
                  </li>
                ))}
              </ul>
            ) : searchQuery.trim() ? (
              <div className="px-4 py-8 text-center" style={{ color: 'var(--text-muted)' }}>
                <p className="text-sm font-mono">No results for "{searchQuery}"</p>
              </div>
            ) : (
              <div className="px-4 py-4">
                <p className="text-xs font-mono mb-3" style={{ color: 'var(--text-muted)', letterSpacing: '0.1em' }}>
                  POPULAR CATEGORIES
                </p>
                <div className="flex flex-wrap gap-2">
                  {['Switches', 'Sockets', 'MCB', 'Regulators', 'Holders'].map(cat => (
                    <button
                      key={cat}
                      onClick={() => setSearchQuery(cat)}
                      className="filter-pill"
                    >
                      {cat}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
}
